import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { IMG } from "@/lib/images";
import PageBanner from "@/components/common/PageBanner";

const ARTICLES = [
  { cat: "DOOH Trends", title: "Why India&apos;s mall DOOH is outgrowing traditional OOH 3×", excerpt: "Programmatic DOOH inside premium malls is now the fastest-growing segment of Indian out-of-home.", img: IMG.escalator },
  { cat: "Retail Media", title: "The 2026 playbook for retail media inside Indian malls", excerpt: "Audience segmentation, attribution windows, brand-lift studies — how the smartest brands are operating retail media in 2026.", img: IMG.hangingBanner },
  { cat: "Experiential", title: "Sampling that actually converts: 5 frameworks", excerpt: "From hand-cream pop-ups to vehicle reveals — operating models that turn mall traffic into real conversions.", img: IMG.popupBooth },
  { cat: "Buyer&apos;s Guide", title: "Mall advertising in India — a complete buyer&apos;s manual", excerpt: "Format-by-format, city-by-city. The definitive guide for marketers planning mall media in India.", img: IMG.backlitPillar },
  { cat: "Shopper Behaviour", title: "Inside India&apos;s premium mall shopper — 2026 data report", excerpt: "Dwell time, conversion paths, category cross-shopping — what the new affluent Indian shopper actually does.", img: IMG.foodCourt },
  { cat: "Media Planning", title: "From brief to live: a 14-day mall campaign workflow", excerpt: "The exact operating cadence top agencies use to ship a multi-city mall campaign in two weeks.", img: IMG.exteriorLightbox },
];

export default function Resources() {
  return (
    <div data-testid="resources-page" className="bg-[var(--bone)]">
      <PageBanner
        eyebrow="Retail Media Insights"
        title="Frameworks, data and playbooks for"
        italicWord="India's retail-media decade."
        image={IMG.bengaluru}
      />
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--border)]">
        {ARTICLES.map((a, idx) => (
          <motion.article
            key={idx}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.05 }}
            className="bg-[var(--bone)] group cursor-pointer"
            data-testid={`article-${idx}`}
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img src={a.img} alt="" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 img-luxe" loading="lazy" />
              <div className="absolute inset-0 hero-overlay" />
              <div className="absolute top-4 left-4 chip bg-white/95">{a.cat}</div>
            </div>
            <div className="p-7">
              <h3 className="font-serif-display text-2xl text-[var(--ink)] leading-tight" dangerouslySetInnerHTML={{ __html: a.title }} />
              <p className="mt-3 text-sm text-[var(--slate-1)] leading-relaxed" dangerouslySetInnerHTML={{ __html: a.excerpt }} />
              <div className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-semibold text-[var(--gold)]">
                Read · coming soon <ArrowUpRight size={11} />
              </div>
            </div>
          </motion.article>
        ))}
      </section>
      <section className="max-w-3xl mx-auto px-6 md:px-10 lg:px-16 py-16 text-center">
        <BookOpen size={32} className="text-[var(--gold)] mx-auto" strokeWidth={1.4} />
        <h2 className="mt-5 font-serif-display text-3xl lg:text-5xl text-[var(--ink)]">
          The next data drop, <span className="font-serif-italic text-[var(--gold)]">in your inbox.</span>
        </h2>
        <p className="mt-3 text-[var(--slate-1)]">Monthly. No spam. Always free.</p>
        <Link to="/contact" className="mt-8 inline-flex btn-primary">Subscribe via Contact</Link>
      </section>
    </div>
  );
}
